/**
 * Static list of countries excluded from App Locked Deals
 * https://app.shortcut.com/findhotel/story/101123/app-exclusive-deal-exclusions
 */

const countriesExcludedFromAppLockedDeals = new Set([
  'AF',
  'AM',
  'AZ',
  'BD',
  'BT',
  'BN',
  'CN',
  'GE',
  'HK',
  'IN',
  'ID',
  'JP',
  'MY',
  'MV',
  'MN',
  'MM',
  'NP',
  'PK',
  'TW',
  'TH',
  'TL',
  'VN',
  'DZ',
  'CV',
  'EG',
  'ER',
  'TF',
  'GM',
  'KZ',
  'MU',
  'MA',
  'RE',
  'ZW',
  'KP',
  'SG',
  'BJ',
  'BW',
  'CF',
  'CI',
  'KE',
  'YT',
  'NE',
  'SH',
  'SS',
  'TM',
  'ZM',
  'KM',
  'TG',
  'KR',
  'LA',
  'PS',
  'LK',
  'CM',
  'CD',
  'SZ',
  'GA',
  'GH',
  'GN',
  'LR',
  'LY',
  'MG',
  'SC',
  'MO',
  'TR',
  'AO',
  'BI',
  'DJ',
  'GQ',
  'ET',
  'MZ',
  'NA',
  'NG',
  'SN',
  'SO',
  'ZA',
  'SD',
  'TZ',
  'UZ',
  'EH',
  'BF',
  'MW',
  'SL',
  'TD',
  'ML',
  'KH',
  'PH',
  'IO',
  'CG',
  'KG',
  'MR',
  'RW',
  'TN',
  'UG',
  'GW',
  'LS',
  'ST',
  'TJ'
])

/**
 * @param countryCode - The user's country code
 * @returns Whether the static list contains the provided country code
 */
export const getIsCountryExcludedFromAppLockedDeals = (countryCode: string) => {
  return countriesExcludedFromAppLockedDeals.has(countryCode)
}
